import React, { useContext, useEffect, useState } from 'react';
import ContactBg from '../../../assets/images/bg/contact-bg2.png';
import Clean from '../../../assets/images/clean-women.png';
import Circle from '../../../assets/images/circle-shape.png';
import { notification, Switch } from 'antd';
import secureLocalStorage from 'react-secure-storage';
import { axiosInstance } from '../config';
import Loader from '../../common/Loader';
import { ServicesContext } from '../../Reusable/ServiceContextmain';
import { DatePicker } from 'antd';
import dayjs from 'dayjs';

const Contact = () => {
  const [isTenderQuery, setIsTenderQuery] = useState(false);
  const date = new Date();
  const minDateTime = date.toISOString().slice(0, 16);
  const { services, loading, error } = useContext(ServicesContext);
  const [Loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    datetime: '',
    servicename: 'Your Service',
    message: '',
    noOfProperties: '',
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name } = e.target;
    let { value } = e.target;

    if (name === 'phone') {
      value = value.replace(/[^0-9]/g, '').slice(0, 15);
    }
    setFormData({
      ...formData,
      [name]: value,
    });
    setErrors({
      ...errors,
      [name]: '', // Clear the error for the current field
    });
  };

  const handleSwitchChange = (checked) => {
    setIsTenderQuery(checked); // Update the state based on the switch value
  };

  const validate = () => {
    const newErrors = {};

    if (!formData.name) {
      newErrors.name = 'Name is required.';
    }

    if (!formData.email) {
      newErrors.email = 'Email is required.';
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = 'Email is invalid.';
    }

    if (!formData.datetime) {
      newErrors.datetime = 'Date and time are required.';
    }

    if (!formData.phone) {
      newErrors.phone = 'Phone number is required.';
    } else if (formData.phone.length < 10) {
      newErrors.phone = 'Please enter a valid phone number.';
    }

    if (formData.servicename === 'Your Service') {
      newErrors.servicename = 'Please select a service.';
    }

    if (!formData.message) {
      newErrors.message = 'Message is required.';
    }
    if (isTenderQuery && !formData.noOfProperties) {
      newErrors.noOfProperties = 'No. of Properties is required.';
    }
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
    } else {
      setLoading(true);
      try {
        const EnquiryData = {
          ...formData,
          tendercontract: isTenderQuery ? 1 : 0,
        };

        const response = await axiosInstance.post(`/inquiry/add`, EnquiryData);
        if (response?.data?.success) {
          notification.open({
            message: (
              <div className="d-flex">
                <div className="pr-20">
                  <i
                    className="bi bi-check2-circle text-success"
                    style={{ fontSize: '20px' }}
                  ></i>
                </div>
                <div>Enquiry Submitted Successfully</div>
              </div>
            ),
            description: 'You can expect a call in 24 hours from our team.',
          });
          setFormData({
            name: '',
            email: '',
            phone: '',
            datetime: '',
            servicename: 'Your Service',
            message: '',
            noOfProperties: '',
          });
          setLoading(false);
        } else {
          notification.open({
            message: (
              <div className="d-flex">
                <div className="pr-20">
                  <i
                    className="bi bi-exclamation-circle-fill text-danger"
                    style={{ fontSize: '20px' }}
                  ></i>
                </div>
                <div>Opps! Something went wrong.</div>
              </div>
            ),
            description: 'Try Again !',
          });
          setFormData({
            name: '',
            email: '',
            phone: '',
            datetime: '',
            servicename: 'Your Service',
            message: '',
            noOfProperties: '',
          });
        }
      } catch (e) {
        setLoading(false);
      }
    }
  };

  return (
    <div>
      {Loading && <Loader />}
      <div className="rs-contact contact-style1 pb-120 md-pb-80">
        <div className="container custom">
          <div className="row margin-0 align-items-end">
            <div className="col-lg-6 padding-0 shape-divider-bg video-item">
              <div className="widget-viwe-line">
                <div className="clean-img">
                  <img className="top-image" src={Clean} alt="Images" />
                  <div className="rotote-img">
                    <img className="rotated-style" src={Circle} alt="Images" />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6 padding-0 space-divider">
              <div className="widget-wrap">
                <div className="rs-requset">
                  <div className="sec-title mb-33">
                    <span className="sub-text green-color yellow-color">
                      Let’s talk
                    </span>
                    <h2 className="title white-color">Request a Quote</h2>
                  </div>
                  <div className="contact-widget">
                    <div id="form-messages"></div>
                    <form onSubmit={handleSubmit}>
                      <fieldset>
                        <div className="row">
                          <div className="col-lg-6 mb-30 col-md-6 col-sm-6">
                            <input
                              className={`from-control ${errors.name ? 'error' : ''}`}
                              type="text"
                              id="name"
                              name="name"
                              placeholder="Name"
                              value={formData.name}
                              onChange={handleChange}
                            />
                            {errors.name && (
                              <span className="text-danger ps-1">
                                * {errors.name}
                              </span>
                            )}
                          </div>
                          <div className="col-lg-6 mb-30 col-md-6 col-sm-6">
                            <input
                              className={`from-control ${errors.email ? 'error' : ''}`}
                              type="text"
                              id="email"
                              name="email"
                              placeholder="E-Mail"
                              value={formData.email}
                              onChange={handleChange}
                            />
                            {errors.email && (
                              <span className="text-danger ps-1">
                                * {errors.email}
                              </span>
                            )}
                          </div>
                          <div className="col-lg-6 mb-30 col-md-6 col-sm-6">
                            <input
                              className={`from-control ${errors.phone ? 'error' : ''}`}
                              type="tel"
                              id="phone"
                              name="phone"
                              placeholder="Phone Number"
                              value={formData.phone}
                              onChange={handleChange}
                              maxLength={15}
                            />
                            {errors.phone && (
                              <span className="text-danger ps-1">
                                * {errors.phone}
                              </span>
                            )}
                          </div>
                          <div className="col-lg-6 mb-30 col-md-6 col-sm-6">
                            <DatePicker
                              showTime={{
                                use12Hours: true,
                                format: 'hh:mm A',
                              }}
                              format="DD/MM/YYYY hh:mm A"
                              placeholder="dd/mm/yyyy --:-- --"
                              allowClear={false}
                              inputReadOnly={true}
                              disabledDate={(current) =>
                                current && current < dayjs().startOf('day')
                              }
                              style={{
                                width: '100%',
                                height: '54px',
                              }}
                              value={
                                formData.datetime
                                  ? dayjs(formData.datetime)
                                  : null
                              }
                              onChange={(date) => {
                                if (!date) return;

                                setFormData((prev) => ({
                                  ...prev,
                                  datetime: date.format('YYYY-MM-DD HH:mm:ss'),
                                }));

                                setErrors((prev) => ({
                                  ...prev,
                                  datetime: '',
                                }));
                              }}
                              getPopupContainer={(trigger) =>
                                trigger.parentNode
                              }
                            />
                            {errors.datetime && (
                              <span
                                className="text-danger ps-3"
                                style={{ fontSize: '14px' }}
                              >
                                * {errors.datetime}
                              </span>
                            )}
                          </div>
                          <div className="col-12 mb-30">
                            <select
                              name="servicename"
                              className={`wpcf7-form-control wpcf7-select ${errors.servicename ? 'error' : ''}`}
                              value={formData.servicename}
                              onChange={handleChange}
                            >
                              <option value="Your Service">Your Service</option>
                              {Array.isArray(services) &&
                                services.map((item) => (
                                  <option key={item.id} value={item.id}>
                                    {item.name}
                                  </option>
                                ))}
                            </select>
                            {errors.servicename && (
                              <span className="text-danger ps-2">
                                * {errors.servicename}
                              </span>
                            )}
                          </div>
                          <div className="d-flex justify-content-between home-contact">
                            <h6 className="form-Query mb-3 text-white">
                              Is This Query For Tender Contract?
                            </h6>
                            <Switch
                              defaultChecked={false}
                              onChange={handleSwitchChange}
                            />
                          </div>
                          {isTenderQuery && (
                            <div className="col-lg-12 mb-3">
                              <input
                                type="number"
                                min={1}
                                className={`from-control ${
                                  errors.noOfProperties ? 'error' : ''
                                }`}
                                id="noOfProperties"
                                name="noOfProperties"
                                placeholder="No. of Properties"
                                value={formData.noOfProperties}
                                onChange={handleChange}
                              />

                              {errors.noOfProperties && (
                                <span
                                  style={{
                                    color: 'red',
                                    fontSize: '14px',
                                    display: 'block',
                                    marginTop: '5px',
                                  }}
                                >
                                  {errors.noOfProperties}
                                </span>
                              )}
                            </div>
                          )}
                          <div className="col-lg-12 mb-30">
                            <textarea
                              className={`from-control ${errors.message ? 'error' : ''}`}
                              id="message"
                              name="message"
                              placeholder="Your Message"
                              value={formData.message}
                              onChange={handleChange}
                            />
                            {errors.message && (
                              <span className="text-danger ps-2">
                                * {errors.message}
                              </span>
                            )}
                          </div>
                        </div>
                        <div className="form-group mb-0">
                          <p className="submit-btn">
                            <input
                              type="submit"
                              value="Submit Now"
                              disabled={Loading}
                            />
                          </p>
                        </div>
                      </fieldset>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="address-wrap">
            <div className="address-icon">
              <i className="bi bi-telephone-fill"></i>
            </div>
          </div>
        </div>
        <div className="contact-animate">
          <div className="animate-style">
            <img className="scale" src={ContactBg} alt="" />
          </div>
        </div>
      </div>
    </div>
  );
};
export default Contact;
